import * as React from 'react'
import clsx from 'clsx'

interface LayoutProps {
	children: React.ReactNode
	id?: string
	classNameContainer?: React.HTMLAttributes<HTMLElement>['className'] & {}
	classNameInnerContainer?: React.HTMLAttributes<HTMLElement>['className'] & {}
}

const Layout: React.FC<LayoutProps> = ({ children, id, classNameContainer, classNameInnerContainer }) => {
	return (
		<div
			id={ id }
			className={clsx(
				'px-6 w-full flex justify-center items-center',
				'md:px-0',
				classNameContainer
			)}
		>
			<div
				className={clsx(
					'w-full flex justify-between',
					'md:px-22 md:max-w-360',
					classNameInnerContainer
				)}
			>
				{ children }
			</div>
		</div>
	)
}

export default Layout
